import { Edit as EditIcon } from "@mui/icons-material";
import { Avatar, Badge, Grid, IconButton, styled } from "@mui/material";
import { type ChangeEvent, useEffect } from "react";

/** @deprecated We are phasing out `cc-ui` */
export interface PictureUploadProps {
  onChange: (f: File) => void;
  imageUrl?: string;
  name: string;
}

const tHelp = "Click to upload a new image";
const INPUT_ID = "CrowdCoursing-picture-input";
const HiddenInput = styled("input")({ display: "none" });

/**
 * `PictureUpload` covers room and profile picture changing.
 * @deprecated We are phasing out `cc-ui`
 */
export const PictureUpload = ({ imageUrl, onChange, name }: PictureUploadProps) => {
  const initials = name
    .split(" ")
    .map((part) => part[0])
    .filter(Boolean)
    .join("")
    .toUpperCase();
  useEffect(() => {
    const img = new Image();
    if (imageUrl) {
      img.src = imageUrl;
    }
  }, [imageUrl]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.length == 1) {
      onChange(event.target.files[0]);
    }
  };

  return (
    <label data-testid="PictureUpload" htmlFor={INPUT_ID} title={tHelp}>
      <HiddenInput accept="image/*" id={INPUT_ID} onChange={handleChange} type="file" />
      <Grid id="profile-picture">
        <Badge
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          badgeContent={
            <IconButton
              aria-label="Edit profile picture"
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                document.getElementById(INPUT_ID)?.click();
              }}
              sx={{
                "&:focus-visible": {
                  outline: (theme) => `2px solid ${theme.palette.primary.main}`,
                  outlineOffset: "2px",
                },
                "&:hover": {
                  backgroundColor: "primary.light",
                },
                backgroundColor: "primary.main",
                border: "2px solid",
                borderColor: "primary.main",
                color: "white",
              }}
            >
              <EditIcon fontSize="large" />
            </IconButton>
          }
          overlap="circular"
        >
          <Avatar
            slotProps={{ img: { "aria-label": `${name} Avatar` } }}
            src={imageUrl}
            sx={{
              cursor: "pointer",
              fontSize: "2rem",
              height: (theme) => theme.spacing(25),
              width: (theme) => theme.spacing(25),
            }}
          >
            {initials}
          </Avatar>
        </Badge>
      </Grid>
    </label>
  );
};
